import { render, staticRenderFns } from "./ViewExpenses.vue?vue&type=template&id=1e2984c1"
import script from "./ViewExpenses.vue?vue&type=script&lang=js"
export * from "./ViewExpenses.vue?vue&type=script&lang=js"
import style0 from "./ViewExpenses.vue?vue&type=style&index=0&id=1e2984c1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports